import { render } from "./DemandEdit.vue?vue&type=template&id=40410f64&scoped=true&ts=true"
import script from "./DemandEdit.vue?vue&type=script&lang=ts"
export * from "./DemandEdit.vue?vue&type=script&lang=ts"

import "./DemandEdit.vue?vue&type=style&index=0&id=40410f64&scoped=true&lang=css"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40410f64"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QSpinnerFacebook,QTabPanels,QTabPanel,QBtn,QTooltip,QMenu,QList,QItem,QItemSection,QExpansionItem});qInstall(script, 'directives', {ClosePopup});
